<section>
    <div class="card cards card-2 text-center mb-2" style="width: 90%;">
        <div class="card-body">
            <img class="img-fluid mb-5" width="300" src="./assets/img/communoplus_logo.jpg" alt="CommunoPlus">
            <ng-container [ngSwitch]="mode">
                <!-- password reset -->
                <ng-container *ngSwitchCase="'resetPassword'">
                    <div class="">
                        <div *ngIf="!pwdUpdateStatus">
                            <div class="mb-5">
                                <h5 class="card-title">{{ getText('passwordResetTitle') }}</h5>
                                <p class="text-muted mb-0">
                                    {{ getText('passwordResetDescription') }}
                                </p>
                            </div>
                            <form>
                                <div class="form-group">
                                    <label class="form-control-label">{{ getText('password') }}</label>
                                    <div class="input-group">
                                        <input #inputPassword type="password" class="form-control"
                                            placeholder="Password" [(ngModel)]="password"
                                            [ngModelOptions]="{standalone: true}">
                                        <div class="input-group-append show-pass1"
                                            (click)="toggleEyeIcon(inputPassword)">
                                            <span class="input-group-text ">
                                                <i class="fa"
                                                    [ngClass]="{'fa-eye-slash': toggleEye, 'fa-eye': !toggleEye}"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-4">
                                    <button type="button" class="btn btn-block main-btn" (click)="savePassword()">{{
                                        getText('passwordResetTitle') }}</button>
                                </div>
                            </form>
                        </div>
                        <div *ngIf="pwdUpdateStatus">
                            <button type="button" class="btn btn-block main-btn" (click)="continueToApp()">{{
                                getText('continue') }}</button>
                        </div>
                    </div>
                </ng-container>

                <!-- verify email address -->
                <ng-container *ngSwitchCase="'verifyEmail'">
                    <div class="">
                        <div class="container h-100">
                            <div class="mb-5">
                                <h5 class="card-title">{{ getText('emailVerificationTitle') }}</h5>
                            </div>
                            <div class="">
                                <div class="">
                                    <div class="form-input-content text-center error-page">
                                        <h1 class="error-text font-weight-bold">
                                            <i
                                                [ngClass]="verifiedStatus ? 'fa fa-check text-success' : 'fa fa-times-circle text-danger'"></i>
                                        </h1>
                                        <p>{{ message }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-4">
                                <button type="button" class="btn btn-block main-btn" (click)="continueToApp()">{{
                                    getText('continue') }}</button>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <!-- default action -->
                <ng-container *ngSwitchDefault>
                    <div class="mb-5">
                        <img src="assets/img/loading.gif" alt="">
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </div>
</section>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-clip-rotate-pulse" [fullScreen]="true">
    <p style="color: white"> Loading... </p>
</ngx-spinner>